module.exports = {
      id: "listary_more2_pic-usage",
      viewBox: "0 0 500 304",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#listary_more2_pic-usage",
      toString: function () {
        return this.url;
      }
    }